<div class="productLabelLandingPage">
  <div class="fulfillmentLanding cpp-wrapper">
    <div class="status-bar">
      Product label ordering is available only to customers with a repack agreement with Winfield United. Contact Winfield United customer service to sign your repack agreement and order product labels.
    </div>
    <!-- style="overflow:auto;margin-right:-15px;"-->
    <div class="cppLandingPage">
      <div class="row">
        <div class="col-md-12 col-lg-12 margin-l0 cppTopSec">
          <h3>
           Product Label Orders
          </h3>
        </div>
      </div>
      <div class="form-sec">
        <div class="row margin-t10 margin-b10 margin-r0">
          <div class="col-sm-12 col-md-9 col-lg-9 col-xl-10  margin-l0">
            <div class="row search-box-outer ">
              <div class="col-4 col-md-4 col-lg-3 padding-r0 category-drop-outer borderRight">

                <div class="category-dropdown material-select">
                  <ng-select [(ngModel)]="selectedValue"
                             name="ddlProductSearch"
                             [virtualScroll]="true"
                             [closeOnSelect]="true"
                             [selectOnTab]="true"
                             [clearable]="false"
                             [searchable]="false"
                             (change)="retainFilter(null, ' ')"
                             data-testid="ddl-cpp-filter">
                    <ng-option *ngFor="let data of searchTypeList;let i=index" [value]="data">
                      <span [attr.data-testid]="'ddl-cpp-filter_'+i">{{data}}</span>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="col-8 col-md-8 col-lg-9 padding-l4 padding-r0 ">
                <div class="row material-select reports-search-filter">

                  <div #productSearch *ngIf="selectedValue === 'Product Name'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-product-search" (keyup.enter)="retainFilter(null, ' ');getProductLabelOrders();" [(ngModel)]="productFilters.ProductName"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div #productSearch *ngIf="selectedValue === 'Account No' " class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-account-no-search" (keyup.enter)="retainFilter(null, ' ');getProductLabelOrders();" [(ngModel)]="productFilters.TxtAccountNo"
                                 placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div #productSearch *ngIf="selectedValue === 'Account Name'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-account-name-search" (keyup.enter)="retainFilter(null, ' ');getProductLabelOrders();" [(ngModel)]="productFilters.AccountName"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Order Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput data-testid="ddl-order-date-from-search" [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromOrderDateFilter"
                               readonly [(ngModel)]="productFilters.FromOrderDate" (dateChange)="retainFilter(null, ' ');validateOrderDateFilter('fromOrderDate', $event);">
                        <mat-datepicker-toggle data-testid="ddl-order-date-from-icon" matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 maturitySelect" *ngIf="selectedValue === 'Order Date'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput data-testid="ddl-order-date-to-search" [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toOrderDateFilter"
                               readonly [(ngModel)]="productFilters.ToOrderDate" (dateChange)="retainFilter(null, ' ');validateOrderDateFilter('toOrderDate', $event);">
                        <mat-datepicker-toggle data-testid="ddl-order-date-to-icon" matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div *ngIf="selectedValue == 'Order Number'" class="wide100">
                    <div class="search-box-outer">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input data-testid="ddl-order-id-search" (keyup.enter)="retainFilter(null, ' ');getProductLabelOrders();" [(ngModel)]="productFilters.OrderNumber"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 col-xl-2 search-btn-outer text-right">
            <div class="row">
              <div class="col-12 pr-0">
                <div class="search-btn pl-2 text-left">
                  <button mat-raised-button class="btns w140" data-testid="ddl-cpp-search" (click)="retainFilter(null, ' ');getProductLabelOrders();" color="primary">Search</button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 padding-r0">
            <div class="chips-sec">
              <div class="row selected-chip xs-pt-0 md-pt-10">
                <div class="col-9 col-md-10 padding-l0">
                  <div>
                    <mat-chip-set>
                      <mat-chip selected *ngFor="let filterValue of filterValueList">
                        {{filterValue}}
                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                          <i class="fas fa-times text-right"></i>
                        </a>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                </div>
                <div class="col-3 col-md-2 text-right padding-r30" *ngIf="filterValueList.length > 0">
                  <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2  button-t20 d-sm-none d-none d-md-block sm-hide pl-2">
            <button data-testid="ddl-create-new" *ngIf="!readOnlyAccess" mat-raised-button class="btns wide100 p-2 index-z200" color="primary" (click)="createNewOrder()">Create New Label Order</button>
          </div>
        </div>
      </div>

      <div class="row">
        

        <div class="col-md-12 xs-mt-0 md-mt-0 margin-t-30">
          <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab">

            <mat-tab>
              <ng-template mat-tab-label>
                <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
                <div class="tab-head">
                  <h4>
                    Placed Orders
                  </h4>
                </div>
              </ng-template>
              <div class="fulfill-top-sec">
                <div class="row listing-action-items">
                  <div class="col-sm-4">
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                    <div class="display-ib wAuto">
                      <mat-paginator #placedProductLabelOrdersPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tableContainer">
                <table mat-table #placedProductLabelOrderTable [dataSource]="productLabelOrderDataSource" matSort #productLabelOrderSort matSortDirection="desc" class="matTables productLabelTable">
                  <ng-container matColumnDef="orderNumber">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Order Number</th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <div class="order-info">
                          <p class="font14">
                            {{element.orderNumber}}
                          </p>                        
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="accountName">
                    <th mat-header-cell *matHeaderCellDef  class="return-request  text-left pl-3">Account Name</th>
                    <td mat-cell *matCellDef="let element">
                      <div class="order-info">
                        <p class="grower-name">
                          {{element.accountName}}
                        </p>
                        <p class="font14 accountAddress">{{element.address}}, {{element.city}}, {{element.state}} {{element.zipCode}}</p>
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>  </td>
                  </ng-container>
                  <ng-container matColumnDef="accountNumber">
                    <th mat-header-cell *matHeaderCellDef  class="dsmNo  text-center">Account #</th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      {{element.accountNumber}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="orderDate">
                    <th mat-header-cell *matHeaderCellDef  class="requestDate  text-center">Order Date</th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      {{element.orderDate | date: masterConstants.DATE_MMDDYYYY}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="viewOrder">
                    <th mat-header-cell *matHeaderCellDef class="actionBtn text-center"></th>
                    <td mat-cell *matCellDef="let element" class="text-right">
                      <div>
                        <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                          <i class="fas fa-ellipsis-v blue-color"></i>
                        </button>
                        <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                 
                          <button mat-menu-item (click)="generatedPdf(element)">Download PDF</button>
                        </mat-menu>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="productLabelOrderColumns;sticky:true;"></tr>
                  <tr mat-row *matRowDef="let row; columns: productLabelOrderColumns;"></tr>
                </table>
                <div *ngIf="productLabelOrderList == undefined || productLabelOrderList.length == 0" class="noDataMsg">
                  <p class="padding-b47">No Record Found.</p>
                </div>
              </div>
            </mat-tab>

          </mat-tab-group>
        </div>
        
      </div>
    </div>
  
  </div>
</div>
